export class ShortcutsConfiguration {
  key: string;
  value: string;
}

export const defaultShortcutList = {
  'bold': 'Mod-b',
  'italic': 'Mod-i',
  'underline': 'Mod-u',
  'align-left': 'Mod-l',
  'align-center': 'Mod-g',
  'align-right': 'Mod-r',
  'align-justify': 'Mod-j',
  'refresh': 'Mod-q',
  'suggestion-open': 'Mod-e',
  'apply-normality': 'Mod-y',
  'select': 'Enter',
  'page-up': 'PageUp',
  'page-down': 'PageDown',
  'esc': 'Escape',
  'ordered-list' : 'Mod-o',
  'unordered-list' : 'Mod-k'
};
